import { CircularProgress, Grid } from '@mui/material';

export const BadgeLoading = () => {
  return (
    <Grid
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100px',
      }}
    >
      <CircularProgress />
    </Grid>
  );
};
